<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <img src="@/assets/bookmark_logo.png" alt="アリスぶ" class="mb-5" style="width: 200px;">
      </v-layout>
    </v-slide-y-transition>
        <v-layout row wrap justify-center>
        <v-flex xs12 md6>
          <v-text-field label="Twitterユーザー名" v-model="username" single-line solo />
          <v-alert :value="error" type="error" v-text="error" />
          <v-btn color="primary" outline block @click.native="toPage">ブックマーク一覧へ</v-btn>
        </v-flex>
        </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        username: '',
        error: null
      }
    },
    methods: {
      toPage () {
        this.error = null
        if (this.username.trim().length <= 0) {
          this.error = 'Twitterユーザー名を入力してください'
          return
        }
        this.$router.push('/bookmark/' + this.username.trim())
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue